import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { useRecoilValue } from "recoil";
import { EmployeeAdOverrideGroupTable } from "./EmployeeAdOverrideTable";

export const EmployeeAdOverrideGroup = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_employeeadoverridegroup_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) && (
        <EmployeeAdOverrideGroupTable />
      )}
    </>
  );
};
